module.exports = __webpack_public_path__ + "img/stockBtnJaune.d06fd8f6.png";